import { useEffect, useRef } from "react";

// Junta as mudanças que chegam na mesma releitura da lista numa busca só.
const ESPERA_MS = 800;

/**
 * Chama `recarregar` quando a assinatura dos pedidos muda (ver assinaturaEtapas).
 * `null` = lista ainda não carregou. A primeira lista carregada não dispara: a
 * leitura feita ao abrir a tela já cobre.
 */
export function useAoMudarEtapa(assinatura, recarregar) {
  const anterior = useRef(null);
  const recarregarRef = useRef(recarregar);
  recarregarRef.current = recarregar;

  useEffect(() => {
    if (assinatura === null) return undefined;
    if (anterior.current === null || anterior.current === assinatura) {
      anterior.current = assinatura;
      return undefined;
    }
    anterior.current = assinatura;
    const t = setTimeout(() => recarregarRef.current(), ESPERA_MS);
    return () => clearTimeout(t);
  }, [assinatura]);
}
